import { IChainId } from '@/interface'
import { Contract, ethers } from 'ethers'
import ABI from '../abi/erc20'
import { Erc20 } from '../helper/abi/erc20'
import { ContractType, ContractUtils } from './common'

interface IApproveParams {
  spender: string;
  amount?: string;
}
export class TokenContract<
C = Erc20,
CT extends ContractType<C> = ContractType<C>
> extends ContractUtils<C> {
  contract: CT

  constructor (address: string, rpc: string) {
    super(ABI, rpc)

    this.contract = new Contract(address, ABI, this.provider) as CT
  }

  async tokenInfo () {
    // const [name, decimals] = await Promise.all([this.name(), this.decimals()])

    return {
      // name,
      // decimals
    }
  }

  tokenApprove (params: IApproveParams) {
    // return this.approve(params.spender, params.amount || '0x' + 'f'.repeat(64))
  }
}
